import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { BackgroundProcessingProvider } from "@/context/BackgroundProcessingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import GlobalProcessingIndicator from "@/components/GlobalProcessingIndicator";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import UploadPage from "@/pages/UploadPage";
import SummariesPage from "@/pages/SummariesPage";
import ArchivesPage from "@/pages/ArchivesPage";
import SettingsPage from "@/pages/SettingsPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import CasesPage from "@/pages/CasesPage";
import CaseDetailPage from "@/pages/CaseDetailPage";
import SupportTicketsPage from "@/pages/SupportTicketsPage";
import TicketDetailsPage from "@/pages/TicketDetailsPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BackgroundProcessingProvider>
        <div className="App">
          <Toaster 
            position="top-right" 
            closeButton
            duration={5000}
            toastOptions={{
              style: {
                background: '#FFFFFF',
                border: '1px solid #E5E5E5',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
              },
              className: 'custom-toast',
            }}
          />
          <GlobalProcessingIndicator />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload"
                element={
                  <ProtectedRoute>
                    <UploadPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/summaries"
                element={
                  <ProtectedRoute>
                    <SummariesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/archives"
                element={
                  <ProtectedRoute>
                    <ArchivesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment-success"
                element={
                  <ProtectedRoute>
                    <PaymentSuccessPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cases"
                element={
                  <ProtectedRoute>
                    <CasesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/case/:caseId"
                element={
                  <ProtectedRoute>
                    <CaseDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/cases"
                element={
                  <ProtectedRoute>
                    <CasesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/cases/:caseId"
                element={
                  <ProtectedRoute>
                    <CaseDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/support-tickets"
                element={
                  <ProtectedRoute>
                    <SupportTicketsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/support-tickets/:ticketId"
                element={
                  <ProtectedRoute>
                    <TicketDetailsPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      </BackgroundProcessingProvider>
    </AuthProvider>
  );
}

export default App;
